import React from 'react'
import { useParams } from 'react-router'
import { useGetCompanyQuery } from 'generated/graphql'
import { extractHtmlValue } from './ELetterService'
import { useMediaQuery } from '@ifca-root/react-component/src/helpers/PDFFormatter/mediaSize'
import { PDFExport } from '@progress/kendo-react-pdf'

export const ELetterPreview = (props: any) => {
  const {
    previewDetail,
    accountType,
    docType,
    getUsersByAccountAndSoftware,
    remapData,
    page,
    pageLength,
    htmlTemplate,
    isView,
    threshold,
    IsWatermark = false,
    WatermarkText = '',
  } = props

  const { CompanyID }: any = useParams()
  const [width, height] = useMediaQuery()

  const {
    loading: companyLoading,
    error: companyError,
    data: { getCompany: getCompany } = { getCompany: [] },
  } = useGetCompanyQuery({
    fetchPolicy: 'network-only',
    variables: { CompanyID },
  })

  const dataDetails = remapData ? remapData[page] : previewDetail

  const ReturnHTML = () => {
    let htmlContent

    htmlContent = extractHtmlValue(
      htmlTemplate,
      accountType,
      docType,
      previewDetail, // dataDetails
      previewDetail,
      getCompany,
      page,
      pageLength,
      getUsersByAccountAndSoftware,
      threshold,
      IsWatermark,
      WatermarkText
    )

    let parser = new DOMParser()
    let doc = parser.parseFromString(
      htmlContent.replace('height: 297mm', ''),
      'text/html'
    )

    // let PageFooter = doc.getElementById('PageFooter')
    // if (PageFooter) {
    //   PageFooter.style.position = 'absolute'
    //   PageFooter.style.top = '1120px'
    //   PageFooter.style.width = '178.5mm'
    // }

    // Cater for header and footer
    /// Remove footer for first page
    if (page !== pageLength - 1) {
      let PageFooter = doc.getElementById('PageFooter')
      let ItemFooter = doc.getElementById('ItemFooter')
      if (PageFooter) {
        PageFooter.parentNode.removeChild(PageFooter)
      }
      if (ItemFooter) {
        ItemFooter.parentNode.removeChild(ItemFooter)
      }
    }

    /// Remove Header for last page
    if (page !== 0) {
      let PageHeader = doc.getElementById('PageHeader')
      if (PageHeader) {
        PageHeader.parentNode.removeChild(PageHeader)
      }
    }

    // create temporary element
    const tempWrapper = doc.createElement('div')
    tempWrapper.style.visibility = 'hidden'
    tempWrapper.style.position = 'absolute'
    tempWrapper.style.width = '210mm' // match A4 width
    tempWrapper.innerHTML = doc.documentElement.outerHTML
    document.body.appendChild(tempWrapper)

    // html height

    const PAGE_HEIGHT = 1123
    const totalHeight = tempWrapper.scrollHeight
    const pageCount = Math.ceil(totalHeight / PAGE_HEIGHT)
    const usedOnLastPage = totalHeight - (pageCount - 1) * PAGE_HEIGHT
    const paddingNeeded =
      PAGE_HEIGHT - usedOnLastPage - (pageCount !== 1 ? 80 : 0)

    // remove temporary element
    // document.body.removeChild(tempWrapper)

    // Item Element
    let ItemContent = doc.getElementById('ItemContent')
    let ItemValue = doc.getElementById('ItemValue')

    // AllocItem Element
    let AllocItemContent = doc.getElementById('AllocItemContent')
    let AllocItemValue = doc.getElementById('AllocItemValue')

    // TaxExemption Element
    let TaxExemptionContent = doc.getElementById('TaxExemptionContent')
    let TaxExemptionValue = doc.getElementById('TaxExemptionValue')

    if (TaxExemptionValue && TaxExemptionContent) {
      TaxExemptionValue.style.marginBottom = `${paddingNeeded}px` // Add margin botom for remaining space for a4 (adjust this as needed)
    } else if (AllocItemValue && AllocItemContent) {
      AllocItemValue.style.marginBottom = `${paddingNeeded}px` // Add margin botom for remaining space for a4 (adjust this as needed)
    } else if (ItemValue && ItemContent) {
      ItemValue.style.marginBottom = `${paddingNeeded}px` // Add margin botom for remaining space for a4 (adjust this as needed)
    }

    htmlContent = doc.documentElement.outerHTML

    return htmlContent
  }

  return <div dangerouslySetInnerHTML={{ __html: ReturnHTML() }} />
}

export default ELetterPreview
